<template>
    <div class="permission-list">
        <div class="new-permission-btn" @click="onNewClick">
            <i class="el-icon-plus"></i> Add a new permission
        </div>
        <el-table
            :data="tableData"
            style="width: 100%"
            stripe
            v-loading="processing"
            size="small"
            @row-click="onDetailClick"
            row-class-name="permission-list-item"
        >
            <el-table-column prop="id" label="ID" width="50"></el-table-column>
            <el-table-column prop="display_name" label="Name" width="200"></el-table-column>
            <el-table-column prop="email" label="Email" width="200"></el-table-column>
            <el-table-column
                :filters="nameOptions"
                :filterMethod="onFilter"
                prop="name"
                label="Permission level"
                width="140"
            ></el-table-column>
            <el-table-column label="Created">
                <template slot-scope="scope">{{scope.row.created | formatDate}}</template>
            </el-table-column>
        </el-table>
        <div class="load-more" @click="loadMore" v-if="tableData.length<total">more...</div>
        <PermissionNew :show="showNew" :onClose="onNewClose" />
        <PermissionDetail :show="showDetail" :onClose="onDetailClose" :data="selectedData" />
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex";
import PermissionNew from "@/components/PermissionNew";
import PermissionDetail from "@/components/PermissionDetail";

export default {
    name: "PermissionList",
    components: {
        PermissionNew,
        PermissionDetail
    },
    data() {
        return {
            tableData: [],
            processing: false,
            showNew: false,
            selectedData: null,
            total: 0,
            skip: 0
        };
    },
    mounted() {
        this.tableData = [];
        this.loadData();
    },
    computed: {
        showDetail() {
            if (this.selectedData) {
                return true;
            }
            return false;
        },
        nameOptions() {
            let options = [];
            for (let data of this.tableData) {
                if (
                    options.findIndex(o => {
                        return o.value == data.name;
                    }) < 0
                ) {
                    options.push({
                        text: data.name,
                        value: data.name
                    });
                }
            }
            return options;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        
        loadData({ skip = 0, limit = 50, id = null } = {}) {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `permission`,
                params: {
                    limit,
                    skip,
                    where: `code<>'GENERAL_USER'`
                }
            })
                .then(({ data = {} }) => {
                    ctrl.total = data.total;
                    ctrl.skip += data.results.length;
                    ctrl.tableData = [...ctrl.tableData, ...data.results];
                    if (id) {
                        for (let result of data.results) {
                            if (result.id == id) {
                                ctrl.selectedData = id;
                            }
                        }
                    }
                })
                .catch(err => {
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        onFilter(value, row, column) {
            const property = column["property"];
            return row[property] === value;
        },
        loadMore() {
            this.loadData({ skip: this.skip });
        },
        onNewClick() {
            this.showNew = true;
        },
        onNewClose(reload = false, id = null) {
            this.showNew = false;
            if (reload == true) {
                this.tableData = [];
                this.loadData({ id });
            }
        },
        onDetailClick(row) {
            this.selectedData = row;
        },
        onDetailClose(reload = false) {
            this.selectedData = null;
            if (reload == true) {
                this.tableData = [];
                this.loadData();
            }
        }
    }
};
</script>
<style scoped>
.permission-list {
    background-color: #eee;
}

.new-permission-btn {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #333;
    text-align: center;
    border: 1px solid #eee;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.new-permission-btn:hover {
    color: #fff;
    background-color: #00669a;
}

.new-permission-btn:active {
    color: #fff;
    background-color: #177CB0;
}
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    margin-top: 16px;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}
</style>

<style >
.permission-list-item {
    cursor: pointer;
}
</style>